import { render, staticRenderFns } from "./ZonasSeguridadForm.vue?vue&type=template&id=562e1556"
import script from "./ZonasSeguridadForm.vue?vue&type=script&lang=js"
export * from "./ZonasSeguridadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports